import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { H2 } from '../../../../components/Typographies/Title';
import { ReactComponent as IconDoodle } from '../../../../images/illustrated/doodle.svg';
import { ReactComponent as IconOkHand } from '../../../../images/illustrated/ok-hand-160.svg';
import { DestinationImage } from './Cards';
import { HIGHLIGHTED_CITIES } from './constants';
import { homePageDestinationsMessages } from './messages';

const Container = styled.div`
  ${tw`relative text-center flex flex-col my-big`}
  gap:var(--size-huge)
`;

const Title = styled(H2)`
  ${tw`relative mx-auto`}
  width:fit-content;

  .highlight {
    ${tw`text-secondary400`}
  }
`;

const Icon = styled(IconDoodle)`
  ${tw`absolute`}
  left: -30px;
  top: -25px;
  transform: rotate(267deg);

  @media (min-width: 768px) {
  }
`;

const Attached = styled.span`
  ${tw`relative`}
`;

const HighlightedCities = styled.div`
  ${tw`relative flex flex-col md:flex-row justify-center items-center mx-auto`}
  gap: var(--size-medium2);
`;

const AbsoluteIcon = styled(IconOkHand)`
  ${tw`hidden xl:block absolute`}
  left: -119px;
  top: 36px;
`;

const Header = () => (
  <Container>
    <Title>
      <Attached>
        <FormattedMessage
          {...homePageDestinationsMessages.destinationsHeaderTitle1}
        />
        <Icon />
      </Attached>
      <FormattedHTMLMessage
        {...homePageDestinationsMessages.destinationsHeaderTitle2}
      />
    </Title>
    <HighlightedCities>
      <AbsoluteIcon />

      {HIGHLIGHTED_CITIES.map((city, index) => (
        <DestinationImage {...city} key={index} />
      ))}
    </HighlightedCities>
  </Container>
);

export default Header;
